export const inventoryTypes = {
  INVENTORIES_INPUTS_FILTERS: "INVENTORIES_INPUTS_FILTERS",

  EDIT_INVENTORY: "EDIT_INVENTORY",

  GET_INVENTORIES: "GET_INVENTORIES",
  GET_INVENTORY_BY_ID: "GET_INVENTORY_BY_ID",
  SET_INVENTORY_DATA_BY_TYPE: "SET_INVENTORY_DATA_BY_TYPE",
  GET_INVENTORY_EXISTENCE: "GET_INVENTORY_EXISTENCE",
  CREATE_GENERAL_INVENTORY: "CREATE_GENERAL_INVENTORY",
  RESET_NEW_INVENTORY_MODE: "RESET_NEW_INVENTORY_MODE",
  SELECT_INVENTORY: "SELECT_INVENTORY",

  SAVE_INVENTORY: "SAVE_INVENTORY",
  SAVE_STATIONARY_INVENTORY: "SAVE_STATIONARY_INVENTORY",
  SAVE_LOCAL_INVENTORY: "SAVE_LOCAL_INVENTORY",
  SAVE_STORAGES_INVENTORY: "SAVE_STORAGES_INVENTORY",
  UPDATE_INVENTORY_PERCENTAGE: "UPDATE_INVENTORY_PERCENTAGE",
  CLOSE_DELETE_INVENTORY: "CLOSE_DELETE_INVENTORY",

  SET_CONFIG_PAGE_INVENTORIES: "SET_CONFIG_PAGE_INVENTORIES",
  SET_CONFIG_PAGE_INVENTORIES_COUNT: "SET_CONFIG_PAGE_INVENTORIES_COUNT",
  SET_CONFIG_SORTED_INVENTORIES: "SET_CONFIG_SORTED_INVENTORIES",
  SET_CONFIG_FILTERED_INVENTORIES: "SET_CONFIG_FILTERED_INVENTORIES",
  RESET_TABLE_CONTROLS: "RESET_TABLE_CONTROLS",

  GET_STORAGES: "GET_STORAGES",
  GET_MOBILE: "GET_MOBILE",
  SET_INVENTORY_DATA: "SET_INVENTORY_DATA",
  TANK_COUNTER: "TANK_COUNTER",
  UPDATE_UNIT_CIL: "UPDATE_UNIT_CIL",
  SET_MOBILE_ENDOWMENTS: "SET_MOBILE_ENDOWMENTS",

  GET_ALL_BY_SHIPMENT_NUMBER: "GET_ALL_BY_SHIPMENT_NUMBER",
  DELETE_SHIPMENT: "DELETE_SHIPMENT",
  GET_SHIPMENT_INVENTORY: "GET_SHIPMENT_INVENTORY",
  REOPEN_INVENTORY: "REOPEN_INVENTORY",
  GET_CARRIER_SHIPMENT_INVENTORY: "GET_CARRIER_SHIPMENT_INVENTORY",
  REOPEN_CPV: "REOPEN_CPV",
  RESTORE_INVENTORY_SAVE: "RESTORE_INVENTORY_SAVE",
  MARK_INVENTORY_LOADED: "MARK_INVENTORY_LOADED",
  SAVE_SHIPMENT: "SAVE_SHIPMENT",

  UPDATE_DIGITAL_STATUS: "UPDATE_DIGITAL_STATUS",
  GET_ALL_SHIPPER_TRUCKS: "GET_ALL_SHIPPER_TRUCKS",

  GET_NATIONAL_NOTES_AVAILABLE: "GET_NATIONAL_NOTES_AVAILABLE",
  TOGGLE_NOTES_NATIONAL: "TOGGLE_NOTES_NATIONAL",
  GET_INVENTORY_CONFIG: "GET_INVENTORY_CONFIG"
};
